import type { WorkspaceDashboardConfig } from "./index.ts";

// Data-only entry point: the browser does not need to evaluate server schemas
// just to restore a layout's defaults.
export const DEFAULT_WORKSPACE_DASHBOARD: WorkspaceDashboardConfig = {
  weeks: 4, density: "comfortable", panel_order: ["inbox", "products"],
  inbox: { groups: ["needs_you", "next", "notices"], limit: 5 }, products: [],
};
